export const projectCreationDataAutomation = {
    button: {
        container: "project-creation-button-container",
        cta: "project-creation-cta-button",
        redirectContainer: "project-creation-redirect-button-container",
        redirectCta: "project-creation-cta-redirect-button",
    },

    alertsButton: {
        cta: "project-creation-alerts-button",
    },

    modal: {
        container: "project-creation-modal",
        header: "project-creation-modal-header",
        subheader: "project-creation-modal-subheader",
        closeButton: "project-creation-close-button",
        createButton: "project-creation-create-button",
    },

    nameInput: {
        container: "project-name-input-container",
        textfield: "project-name-input",
    },

    domainList: {
        container: "domain-list-container",
        header: "domain-list-header",
        list: "domain-list",
    },

    domainListItem: {
        item: "domain-list-item",
        iconContainer: "domain-icon-container",
        icon: "domain-icon",
        text: "domain-text",
        name: "domain-name",
    },

    itemActions: {
        container: "item-actions-container",
        primaryButton: "item-actions-primary-button",
        editButton: "item-actions-edit-button",
        removeButton: "item-actions-remove-button",
    },

    weeklyUpdates: {
        container: "weekly-updates-container",
        switch: "weekly-updates-switch",
        label: "weekly-updates-label",
    },

    successModal: {
        container: "project-creation-success-modal",
        header: "success-modal-header",
        body: "success-modal-body",
        goToProjectsButton: "success-go-to-projects-button",
        continueHereButton: "success-continue-here-button",
    },

    errorModal: {
        container: "project-creation-error-modal",
        header: "error-modal-header",
        body: "error-modal-body",
        contactSupportButton: "error-contact-support-button",
        tryAgainButton: "error-try-again-button",
    },
};
